import { Button } from '@favordelivery/tupperware'
import styled from 'styled-components'
import Section, { SubSection } from './Section'
import { t, tStr } from '@utils/lang'

const TopButton = styled(Button)`
  size: full;
  width: 100%;
  margin-top: 40px;
`
const scrollToTop = () => {
  document.body.scrollTop = 0
  document.documentElement.scrollTop = 0
}

const BackToTop = () => (
  <Section>
    <SubSection title={tStr('backToTopTitle_s')} img={<img src="/images/backToTop.jpeg" alt="" />}>
      {t('backToTopBody_s')}
      <TopButton onClick={scrollToTop}>{t('backToTopCta_s')}</TopButton>
    </SubSection>
  </Section>
)

export default BackToTop
